import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

import ResponsiveModal from '@components/ResponsiveModal';

const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  text-align: left;
  background-color: ${({ theme }) => theme.commons.global.backgroundColor};
  padding-bottom: ${({ theme, withPaddingBottom }) =>
    withPaddingBottom ? theme.spacing(4) : 'inherit'};
  padding-top: ${({ theme, withPaddingTop }) =>
    withPaddingTop ? theme.spacing(4) : 'inherit'};
`;

const modalClass = {
  modal: classnames('modal', { contained: true }),
  overlay: 'modal__overlay',
};

function ModalPage({ open, onClose, children, footer, header }) {
  const modalRef = createRef();

  return (
    <ResponsiveModal
      open={open}
      onClose={onClose}
      center
      closeOnEsc
      closeOnOverlayClick
      ref={modalRef}
      blockScroll={open}
      showCloseIcon={false}
      classNames={modalClass}
    >
      {header}
      <ChildrenContainer
        withPaddingTop={!!header}
        withPaddingBottom={!!footer}
        id="modal__content"
      >
        {children}
      </ChildrenContainer>
      {footer}
    </ResponsiveModal>
  );
}

ModalPage.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.object,
  header: PropTypes.object,
};

ModalPage.defaultProps = {
  header: null,
  footer: null,
};

export default ModalPage;
